import {useEffect, useRef, useState} from "react"

export const useSvgHeight = () => {
	const ref = useRef<SVGSVGElement | null>(null)
	const [height, setHeight] = useState(200)

	useEffect(() => {
		const updateHeight = () => {
			if (ref.current) {
				setHeight(ref.current.getBoundingClientRect().height)
			}
		}
		updateHeight()
		window.addEventListener("resize", updateHeight)
		return () => window.removeEventListener("resize", updateHeight)
	}, [])

	return {ref, height}
}
